import pushToDataLayer, { EVENTS } from './dataLayer/dataLayer';
import { EVENTS as NR_EVENTS, addNewRelicPageAction } from './newRelic';

const doNewRelicActions = ({ data }: any) => {
    if (data['2']) {
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_2);
    }
    if (data['3']) {
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_3);
    }
};

const doGtmActions = ({ data }: any) => {
    // We send exactly one of GDPR_PREF_ALLOWS_2_3, GDPR_PREF_ALLOWS_2, GDPR_PREF_ALLOWS_3 to avoid overwrites
    if (data['2'] && data['3']) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_2_3 });
    } else if (data['2']) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_2 });
    } else if (data['3']) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_3 });
    }
};

/**
 * Called when the customer makes a decision on their cookie permissions
 *
 * @param {string} action
 * @param {object} data
 */
const onCookieManagementEvent = (action: any, data: any) => {
    const functions = {
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        BANNER_INIT: () => addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_1),
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        BANNER_FIRST_RENDER: () => addNewRelicPageAction(NR_EVENTS.BANNER_OPEN),
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        OPEN_COOKIE_MODAL: () => addNewRelicPageAction(NR_EVENTS.MODAL_OPEN),
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        ACCEPT_ALL_COOKIES: () => addNewRelicPageAction(NR_EVENTS.GDPR_ACCEPT_ALL),
        // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
        REJECT_ALL_COOKIES: () => addNewRelicPageAction(NR_EVENTS.GDPR_REJECT_ALL),
        SET_COOKIE_PERMISSIONS: () => {
            doNewRelicActions({ data });
            doGtmActions({ data });
        }
    };
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '
    functions[action]?.();
};

export default onCookieManagementEvent;
